module.exports = __webpack_public_path__ + "img/tracefy-logo-text.afd4ef00.svg";